import React from 'react';
import { SectionReveal } from './ui/SectionReveal';
export function AsFeaturedIn() {
  const outlets = [{
    name: 'TechCrunch',
    style: 'italic'
  }, {
    name: 'Forbes',
    style: 'serif'
  }, {
    name: 'Fortune',
    style: 'serif-bold'
  }, {
    name: 'Entrepreneur',
    style: 'sans'
  }, {
    name: 'Forbes Tech Council',
    style: 'serif'
  }];
  const getClass = (style: string) => {
    switch (style) {
      case 'italic':
        return 'font-serif italic text-2xl md:text-3xl';
      case 'serif':
        return 'font-serif text-2xl md:text-3xl tracking-tight';
      case 'serif-bold':
        return 'font-serif font-bold text-2xl md:text-3xl uppercase tracking-tight';
      case 'sans':
        return 'font-sans font-bold text-xl md:text-2xl uppercase tracking-widest';
      default:
        return 'font-serif text-2xl';
    }
  };
  return <section className="py-16 md:py-20 border-y border-border/50" data-id="element-71">
      <div className="container mx-auto px-6 md:px-12" data-id="element-72">
        <SectionReveal data-id="element-73">
          <p className="text-center text-sm text-muted mb-10 uppercase tracking-widest font-medium" data-id="element-74">
            As featured in & writing for
          </p>
          <div className="flex flex-wrap justify-center items-center gap-x-12 md:gap-x-16 gap-y-8" data-id="element-75">
            {outlets.map((outlet, i) => <span key={i} className={`${getClass(outlet.style)} text-secondary/80 hover:text-primary transition-colors duration-300 cursor-default`} data-id="element-76">
                {outlet.name}
              </span>)}
          </div>
        </SectionReveal>
      </div>
    </section>;
}